import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateTokenisedStringPipe } from '@wdx/shared/utils';
import { MoleculeInputGroupModule } from '../molecule-input-group/molecule-input-group.module';
import { MoleculeInputWrapperModule } from '../molecule-input-wrapper/molecule-input-wrapper.module';
import { MoleculeInputSearchComponent } from './molecule-input-search.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MoleculeInputGroupModule,
        MoleculeInputWrapperModule,
        TranslateTokenisedStringPipe,
    ],
    declarations: [MoleculeInputSearchComponent],
    exports: [MoleculeInputSearchComponent],
})
export class MoleculeInputSearchModule {}
